import Ava from '../../../components/Common/Ava/Ava';
import { getColor, PositionNode } from '../../../utils/helper';

export const TreeNodes = ({ node, setViewPosotionId, setFetching }: { node: PositionNode; setViewPosotionId: Function; setFetching: Function }) => {
    return (
        <div className="tree-node">
            {node.children &&
                node.children.length > 0 &&
                node.children.map((childNode, index) => (
                    <div
                        key={childNode.position.positionId ? childNode.position.positionId : index + childNode.position.accountId}
                        className="tree-col"
                        id={'ind' + index}>
                        <div
                            onClick={() => {
                                if (childNode.position.positionId) {
                                    setViewPosotionId(childNode.position.positionId);

                                    setFetching(true);
                                }
                            }}
                            className="circle-group__circle"
                            style={{ border: !childNode.position.positionId ? '1px solid #0462F9' : 'unset' }}>
                            {childNode.position.positionId ? (
                                <Ava
                                    width="64px"
                                    height="64px"
                                    borderColor={getColor(childNode.position.relationship)}
                                    collectionId={childNode.position.ava?.collectionId}
                                    entityId={childNode.position.ava?.entityId}
                                />
                            ) : (
                                <></>
                            )}
                        </div>
                        {childNode.children ? (
                            <TreeNodes
                                setViewPosotionId={setViewPosotionId}
                                setFetching={setFetching}
                                node={childNode}
                            />
                        ) : (
                            <></>
                        )}
                    </div>
                ))}
        </div>
    );
};
